module.exports = __webpack_public_path__ + "assets/img/code1.2f4ccef4.png";